((): void => {
  if (!import.meta.env.PUBLIC_MAPBOX_ACCESS_TOKEN) {
    throw new Error(
      'Environment variable [PUBLIC_MAPBOX_ACCESS_TOKEN] is not set.'
    );
  }
})();

const MAPBOX_ACCESS_TOKEN = import.meta.env.PUBLIC_MAPBOX_ACCESS_TOKEN;

const MAP_STYLES = {
  dark: 'mapbox://styles/msyfurukawa/ckyslu5uk69d015ssd38o9phz',
  light: 'mapbox://styles/nobuhirojinnai/cl9pag4j2000f14pm82z5p8i8',
} as const;

export { MAPBOX_ACCESS_TOKEN, MAP_STYLES };
